import { render } from "./InputCover.vue?vue&type=template&id=4c058c7c"
import script from "./InputCover.vue?vue&type=script&lang=js"
export * from "./InputCover.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./InputCover.vue?vue&type=style&index=0&id=4c058c7c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script